import type {WikiArticleFragment} from '../../../generated/types';
import {composeDescription} from '../../../lib/seo/text';
import type {OgCardData} from '../../../lib/seo/site';

export function wikiDescription(item: WikiArticleFragment, types: string[] = []): string {
	const parent = item.ancestors[item.ancestors.length - 1];
	const what = types.length ? types.join(', ') : 'статья';
	const where = parent ? `, ${parent.title}` : '';
	return composeDescription(`${item.title} — ${what}${where}, Забытые Королевства`, item.description);
}

export function wikiOgCard(item: Pick<WikiArticleFragment, 'title' | 'originalTitle'>): OgCardData {
	return {label: 'Вики', title: item.title, originalTitle: item.originalTitle, subtitle: 'Забытые Королевства'};
}
